import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getNewComics } from '@/mocks/comics';

export default function LatestUpdatesSection() {
  const newComics = getNewComics();
  const [activeIndex, setActiveIndex] = useState(0);
  const activeComic = newComics[activeIndex] || newComics[0];

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? newComics.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev === newComics.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-12">
          <div className="lg:w-[40%]">
            <Link to={`/comic/${activeComic.id}`} className="block cursor-pointer">
              <div className="relative overflow-hidden rounded-2xl aspect-[3/4] max-w-sm mx-auto lg:max-w-none bg-background-200">
                <img
                  src={activeComic.cover}
                  alt={activeComic.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 to-transparent"></div>
              </div>
            </Link>
          </div>

          <div className="lg:w-[60%] flex flex-col justify-center">
            <p className="text-accent-400 font-label text-xs tracking-[0.2em] uppercase mb-3">
              (本周重磅上新)
            </p>

            <Link to={`/comic/${activeComic.id}`} className="cursor-pointer">
              <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 leading-tight">
                {activeComic.title}
              </h2>
            </Link>

            <p className="mt-2 text-sm text-foreground-500">
              {activeComic.author} / {activeComic.artist}
            </p>

            <blockquote className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed border-l-2 border-primary-400 pl-4 italic">
              &ldquo;{activeComic.description.slice(0, 120)}...&rdquo;
            </blockquote>

            <div className="mt-6 flex items-center gap-3">
              <span className="px-3 py-1 rounded-full text-xs font-label bg-accent-100 text-accent-700">
                {activeComic.category}
              </span>
              <span className="px-3 py-1 rounded-full text-xs font-label bg-primary-100 text-primary-700">
                {activeComic.status}
              </span>
              <span className="text-xs text-foreground-500">
                更新于 {activeComic.updateDate}
              </span>
            </div>

            <div className="mt-8 flex items-center gap-3">
              <button
                onClick={handlePrev}
                className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-500 hover:text-foreground-900 hover:border-foreground-500 transition-all cursor-pointer"
                aria-label="上一部"
              >
                <i className="ri-arrow-left-line"></i>
              </button>
              <button
                onClick={handleNext}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500 text-background-50 hover:bg-accent-600 transition-all cursor-pointer"
                aria-label="下一部"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
              <span className="text-xs text-foreground-500 ml-2">
                {activeIndex + 1} / {newComics.length}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}